module.exports = __webpack_public_path__ + "static/media/clue0301.1252f1c2.png";